export const loadGoogleAnalytics = (id) => {
  if (!id) return;

  if (document.getElementById("ga-script")) return;

  const script = document.createElement("script");

  script.id = "ga-script";

  script.async = true;

  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;

  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];

  function gtag() {
    window.dataLayer.push(arguments);
  }

  gtag("js", new Date());

  gtag("config", id);
};
